import { mapActions } from 'vuex'

export default {
  methods: {
    ...mapActions('modal', ['showModal', 'closeModal']),
    showSuccessFlashMessage (message, options = {}) {
      const { onComplete } = options

      this.showModal({
        name: 'SuccessFlashModal',
        data: { message },
        options: { onComplete }
      })
    },
    showErrorFlashMessage (message, options = {}) {
      const { onComplete } = options

      this.showModal({
        name: 'ErrorFlashModal',
        data: { message },
        options: { onComplete }
      })
    }
  }
}
